import gql from 'graphql-tag'
import graphql from 'utils/graphql'
import {
    UpdateNetworkingSpaceInput,
    UpdateNetworkingMutation,
    UpdateNetworkingMutationVariables
} from 'generated/graphql'

const updateNetworkingMutation = gql`
    mutation updateNetworking($id: ID!, $data: UpdateNetworkingSpaceInput!) {
        updateNetworkingSpace(id: $id, data: $data) {
            id
            parent {
                image
            }
        }
    }
`

export const updateNetworking = (id, data: UpdateNetworkingSpaceInput) => {
    const mutation = graphql.createQuery<
        UpdateNetworkingMutation, UpdateNetworkingMutationVariables
    >(updateNetworkingMutation)
    return mutation({ id, data })
}
